import { EventBus } from "OK/EventBus";

const ClientPropertiesEventBusesPrefix = 'client-properties';
const create = EventBus.factory(ClientPropertiesEventBusesPrefix);

/*
* Событие о том, что внутренний сторадж client-pms получил обновления
* 
* передаваемые данные - наименования обновлённых рубильников
 */
export const PROPERTIES_UPDATE_RECEIVED = create<string[]>('clientPropertiesUpdateReceived');
